import OneStopWorkloadReportingIssues from './OneStopWorkloadReportingIssues';

export default OneStopWorkloadReportingIssues;
